import React from 'react'
import classnames from 'classnames'
import css from './ContentWrapper.module.css'

export default ({ children, noMarginBottom }) => (
  <div className={classnames(css.container, { [`${css.noMarginBottom}`]: noMarginBottom })}>
    {children}
  </div>
)
